import { z } from 'zod';

import { zodTimeStamp } from '@/utils/zodUtils';

export const PAYMENT_LINK_CHANNELS = ['sms', 'email'] as const;
export const PaymentLinkChannelSchema = z.enum(PAYMENT_LINK_CHANNELS);
export type PaymentLinkChannel = z.infer<typeof PaymentLinkChannelSchema>;

export const SentPaymentLinkSchema = z.object({
  sentAt: zodTimeStamp,
  sentBy: z.string(),
  channel: PaymentLinkChannelSchema,
});
export type SentPaymentLink = z.infer<typeof SentPaymentLinkSchema>;

export const PaymentLinkDraftSchema = z.object({
  violationId: z.string(),
  isPayable: z.boolean(),
  message: z.string(),
  paymentLink: z.string(),
  maxMessageLength: z.number().int().positive(),
  lastSent: SentPaymentLinkSchema.nullable(),
});
export type PaymentLinkDraft = z.infer<typeof PaymentLinkDraftSchema>;

export interface SendPaymentLinkPayload {
  channel: PaymentLinkChannel;
  destination: string;
  message: string;
}
